import { creativeBlockHasPartnerPost } from "@common/utils/instagramPartnershipCreative";
import type { CreativeBlock } from "../guidedFlow/types";
import type { FacebookPage, InstagramAccount } from "../types";
import {
  resolveCreativeBlockPartnerPlatforms,
  resolveCreativePartnerFacebookPage,
  resolveCreativePartnerInstagramAccount,
  resolveCreativePartnerInstagramUsername,
} from "./resolveCreativePartnerDisplay";

export type AdPreviewCollaboration = {
  /** Instagram @username shown on IG previews (never a Facebook page name). */
  partnerInstagramUsername?: string;
  partnerInstagramProfilePictureUrl?: string;
  partnerFacebookPageName?: string;
  partnerFacebookPagePictureUrl?: string;
};

export { formatAdPreviewUsername } from "./resolveCreativePartnerDisplay";

/** Resolve partner identity for ad previews from creative + token asset lists. */
export function resolveAdPreviewCollaboration(
  creative: CreativeBlock,
  pages: readonly FacebookPage[],
  instagramAccounts: readonly InstagramAccount[]
): AdPreviewCollaboration | undefined {
  if (!creativeBlockHasPartnerPost(creative)) {
    return undefined;
  }

  const platforms = resolveCreativeBlockPartnerPlatforms(creative);
  if (!platforms.instagram && !platforms.facebook) {
    return undefined;
  }

  const partnerPage = resolveCreativePartnerFacebookPage(creative, pages);
  const partnerIg = resolveCreativePartnerInstagramAccount(
    creative,
    instagramAccounts
  );
  const linkedInstagramUsername =
    partnerPage?.linked_instagram_username?.trim() || undefined;
  const resolvedInstagramUsername =
    resolveCreativePartnerInstagramUsername(creative, instagramAccounts) ||
    linkedInstagramUsername ||
    undefined;

  const partnerFacebookPageName = partnerPage?.name?.trim() || undefined;
  const partnerFacebookPagePictureUrl = partnerPage?.picture?.trim() || undefined;

  if (
    !resolvedInstagramUsername &&
    !partnerFacebookPageName
  ) {
    return undefined;
  }

  return {
    partnerInstagramUsername: resolvedInstagramUsername,
    partnerInstagramProfilePictureUrl:
      partnerIg?.profile_picture_url?.trim() || undefined,
    partnerFacebookPageName,
    partnerFacebookPagePictureUrl,
  };
}
